module.exports = __webpack_public_path__ + "static/media/20.9abab77c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/20.svg
// module id = 133
// module chunks = 0